import { useCallback, useEffect, useState } from "react";
import useDebounce from "./useDebounce";
import { useIsTouchDevice } from "./useIsTouchDevice";
const useHeaderHover = () => {
    const [isHeaderHovered, setIsHeaderHovered] = useState(false);
    const [selectedPageName, setSelectedPageName] = useState(null);
    const [prevSelectedPageName, setPrevSelectedPageName] = useState(null);
    const [showSubMenu, setShowSubMenu] = useState(false);
    const { debounceFn } = useDebounce({ delay: 300 });
    const debouncedSetSelectPageName = debounceFn(setSelectedPageName);
    const debouncedSetPrevSelectedPageName = debounceFn(setPrevSelectedPageName);
    const isTouch = useIsTouchDevice();
    const onNavbarItemEnter = (e, title) => {
        if (e.key === "Enter") {
            setSelectedPageName(title === selectedPageName ? null : title);
        }
    };
    const onNavbarItemMouseEnter = useCallback((title) => {
        // disable mouse enter event
        // when device is mobile
        if (!isTouch) {
            debouncedSetPrevSelectedPageName(title);
            debouncedSetSelectPageName(title);
            setShowSubMenu(true);
        }
    }, [isTouch, debouncedSetSelectPageName]);
    const onNavbarItemClick = useCallback((title) => {
        setPrevSelectedPageName((prevState) => (prevState === title ? null : title));
        setSelectedPageName((prevState) => (prevState === title ? null : title));
        setShowSubMenu((prevState) => !prevState);
    }, [selectedPageName, isTouch]);
    const onNavbarItemMouseLeave = () => {
        setShowSubMenu(false);
    };
    const onNavbarMouseOver = () => {
        return setIsHeaderHovered(true);
    };
    const onNavbarMouseLeave = () => {
        setPrevSelectedPageName(null);
        setIsHeaderHovered(false);
    };
    useEffect(() => {
        if (!showSubMenu) {
            setSelectedPageName(null);
            debouncedSetPrevSelectedPageName.abort();
            debouncedSetSelectPageName.abort();
        }
    }, [showSubMenu, selectedPageName]);
    // Close any opened submenu when device type changes
    useEffect(() => {
        setShowSubMenu(false);
    }, [isTouch]);
    return {
        isHeaderHovered,
        selectedPageName,
        prevSelectedPageName,
        onNavbarMouseOver,
        onNavbarMouseLeave,
        onNavbarItemMouseEnter,
        onNavbarItemMouseLeave,
        onNavbarItemEnter,
        onNavbarItemClick
    };
};
export default useHeaderHover;
